<template>
  <div class="kui-hello">
    {{ msg }}
  </div>
</template>

<script>
export default {
  name: 'kyHello',
  props:{
    msg:{
      type: String
    }
  },
  data(){
    return {
      // msg: 'Hello kui!'
    }
  }
}
</script>

<style scoped>
.kui-hello{
  font-size: 30px;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// packages/hello/Hello.vue